<template>
  <v-form ref="form" class="access-form" @submit.prevent="submit">
    <div class="access-form__grid">
      <rmr-text-field
        v-model="formData.name"
        label="Nom"
        :rules="[required]"
      />
      <rmr-text-field
        v-model="formData.description"
        label="Description"
        :rules="[required]"
      />
      <rmr-autocomplete
        v-model="formData.permissions"
        :items="permissions"
        item-text="name"
        item-value="id"
        label="Permissions"
        multiple
        chips
        deletable-chips
        :rules="[permissionsSelected]"
      />
    </div>

    <div class="access-form__actions">
      <rmr-action-button
        label="Annuler"
        variant="ghost"
        @click="$emit('cancel')"
      />
      <rmr-action-button
        :label="editing ? `Mettre à jour` : `Créer le rôle`"
        :loading="saving"
        type="submit"
      />
    </div>
  </v-form>
</template>

<script>
import { required } from "@core/utils/validation";
import RmrActionButton from "@/components/ui/actions/RmrActionButton.vue";
import RmrAutocomplete from "@/components/ui/forms/RmrAutocomplete.vue";
import RmrTextField from "@/components/ui/forms/RmrTextField.vue";

function buildInitialState(value) {
  const permissionIds =
    value?.permission_ids ||
    (value?.permissions
      ? value.permissions.split(",").map((item) => parseInt(item, 10)).filter(Boolean)
      : []);

  return {
    id: value?.id || null,
    name: value?.name || "",
    description: value?.description || "",
    permissions: permissionIds,
  };
}

export default {
  name: "RoleForm",
  components: {
    RmrActionButton,
    RmrAutocomplete,
    RmrTextField,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      required,
      formData: buildInitialState(this.value),
    };
  },
  computed: {
    editing() {
      return Boolean(this.value && this.value.id);
    },
  },
  watch: {
    value: {
      deep: true,
      handler(nextValue) {
        this.formData = buildInitialState(nextValue);
        this.$nextTick(() => this.$refs.form?.resetValidation());
      },
    },
  },
  methods: {
    permissionsSelected(value) {
      return value && value.length ? true : "Ce champ est obligatoire";
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.$emit("save", {
        name: this.formData.name,
        description: this.formData.description,
        permissions: this.formData.permissions.join(","),
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.access-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.access-form__grid {
  display: grid;
  gap: 16px;
}

.access-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

@media (max-width: 680px) {
  .access-form__actions {
    flex-direction: column-reverse;
  }
}
</style>
